export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith('/') || /[\\\u0000-\u0020]/.test(raw)) return '/';
  try {
    const parsed = new URL(raw, 'https://library.example');
    if (
      parsed.origin !== 'https://library.example' ||
      /^\/(login|register|logout)(\/|$)/i.test(parsed.pathname)
    )
      return '/';
    return parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return '/';
  }
}
